var map = {
	"./lang.ar.json": 339,
	"./lang.bn.json": 976,
	"./lang.en.json": 563,
	"./lang.es.json": 271,
	"./lang.eu.json": 202,
	"./lang.hi.json": 984,
	"./lang.id.json": 649,
	"./lang.pt.json": 364,
	"./lang.ru.json": 205,
	"./lang.tr.json": 950,
	"./lang.ur.json": 423,
	"./lang.uz.json": 47,
	"./lang.vi.json": 181,
	"lang/lang.ar.json": 339,
	"lang/lang.bn.json": 976,
	"lang/lang.en.json": 563,
	"lang/lang.es.json": 271,
	"lang/lang.eu.json": 202,
	"lang/lang.hi.json": 984,
	"lang/lang.id.json": 649,
	"lang/lang.pt.json": 364,
	"lang/lang.ru.json": 205,
	"lang/lang.tr.json": 950,
	"lang/lang.ur.json": 423,
	"lang/lang.uz.json": 47,
	"lang/lang.vi.json": 181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 263;